<div class="card h-100">
    <div class="card-body confirmation-text">
         <span class="k-icon k-i-check-outline k-icon-xl icon-color"></span>
            <p class="confirmation">{{ 'confirmation_sinistre.confirmation' | translate }}</p>
            <p>{{ 'confirmation_sinistre.message_1' | translate }}</p>
            <p>{{ 'confirmation_sinistre.message_2' | translate }}</p>
            <button type="button" (click)="closePage()" class="btn btn-primary close-button"> {{ 'confirmation_sinistre.close' | translate }} </button>
    </div>
</div>